import { parse, ParsedQs } from "qs";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function useParsedQueryString(): ParsedQs {
  const { search } = useLocation();
  return useMemo(
    () =>
      search && search.length > 1
        ? parse(search, { parseArrays: false, ignoreQueryPrefix: true })
        : {},
    [search]
  );
}

export function isAllNumAndCharactersAndChinese(content: string) {
  var reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/;
  if (!reg.test(content)) {
    return false;
  } else {
    return true;
  }
}

export function isAllNumAndCharacters(content: string) {
  var reg = /^[0-9a-zA-Z]+$/;
  if (!reg.test(content)) {
    return false;
  } else {
    return true;
  }
}

export function isAllNum(content: string) {
  var reg = /^[0-9.]+$/;
  if (!reg.test(content)) {
    return false;
  } else {
    return true;
  }
}

export function isEmail(content: string) {
  var reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
  if (!reg.test(content)) {
    return false;
  } else {
    return true;
  }
}

export function isURL(content: string) {
  var reg = /^[A-Za-z]+:\/\/[A-Za-z0-9-_]+\.[A-Za-z0-9-_%&?/.=]+$/;
  if (!reg.test(content)) {
    return false;
  } else {
    return true;
  }
}

export function isEmpty(content: string | undefined | null) {
  var ret = false;
  if (
    content === undefined ||
    content === null ||
    content.length === 0 ||
    content === "null"
  ) {
    ret = true;
  }

  return ret;
}

export function isValidAddress(content: string | undefined | null) {
  var ret = false;
  if (content === undefined || content === null || content.length === 0) {
    ret = false;
  } else {
    if (content.startsWith("0x")) {
      if (isAllNumAndCharacters(content) && content.length > 20) {
        ret = true;
      }
    }
  }

  return ret;
}
